export const WRAP_ITEM_STATUS = {
  PENDING: 'Pending',
  FAILED: 'Failed',
  COMPLETE: 'Complete',
} as const;

export const WRAP_TYPE = {
  NFT: 'Domains',
  TOKEN: 'Tokens',
} as const;
